import api from "./api";

// Capa de servicios API del dominio "audit" (modo espejo / auditoría).
export const startAudit = (userId) => api.post(`/audit/start/${userId}`);
